angular.module('impactx.util').directive('ixDraggable', ['$document', function ($document) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var mousePositionX, mousePositionY;
            var elementPositionX, elementPositionY;
            element.on('mousedown', function (event) {
                mousePositionX = event.clientX;
                mousePositionY = event.clientY;

                var draggableElement = element;
                if(attrs.ixDraggable) {
                    draggableElement = angular.element(attrs.ixDraggable)
                }
                elementPositionX = draggableElement[0].getBoundingClientRect().left;
                elementPositionY = draggableElement[0].getBoundingClientRect().top;

                $document.on('mousemove', function (event) {
                    if (mousePositionX != event.clientX && mousePositionY != event.clientY) {
                        var newTop = event.clientY - mousePositionY;
                        var newLeft = event.clientX - mousePositionX;

                        draggableElement.css({
                            top: elementPositionY + newTop + 'px',
                            left: elementPositionX + newLeft + 'px'
                        });
                    }

                    return false;
                });

                $document.on('mouseup', function () {
                    $document.off('mousemove');
                    $document.off('mouseup');
                });
            });
        }
    }
}]);